/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Track_EmptyInputs */



/**
* | output |
* | --- |
* | "No captions to import in this track." |
*
* @param {Subtitle_Extract_Track_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_track_empty = /** @type {((inputs?: Subtitle_Extract_Track_EmptyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Track_EmptyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun sous-titre à importer pour cette piste.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für diesen Track sind keine Untertitel zum Importieren verfügbar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non è possibile importare sottotitoli in questa traccia.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В этом треке нет субтитров для импорта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay subtítulos para importar en esta pista.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此音轨无需导入字幕。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このトラックにはインポートする字幕がありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस ट्रैक में इंपोर्ट करने के लिए कोई कैप्शन नहीं हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não há legendas para importar nesta faixa.")
	return /** @type {LocalizedString} */ ("No captions to import in this track.")
});